import React, { Component } from 'react';
import './permissionManager.css';
import CompanyService from '../services/CompanyService';
import SearchableDropdown from '../components/common/searchable_dropdown/SearchableDropdown';
import Checkbox from '../components/common/checkbox/Checkbox';
import Tabs from "../components/common/tabs/Tabs";
import Tab from "../components/common/tabs/tab/Tab";
import * as Icon from "react-feather";
import Button from '../components/common/button/Button';

class PermissionsManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissionType: 'User',
      selectedEntityId: "",
      availableResources: {},
      permissions: {},
      dropdownKey: 'dropdown-User'
    };
  }

  componentDidMount() {
    this.fetchAvailablePermissions();
  }

  fetchAvailablePermissions = async () => {
    try {
      const available = await CompanyService.getPermissions();
      this.setState({ 
        availableResources: available, 
        permissions: available 
      });
    } catch (error) {
      console.error("Error fetching available permissions", error);
    }
  };

  getInitialPermissions = () => {
    const { availableResources } = this.state;
    const perms = {};
    Object.keys(availableResources).forEach(resource => {
      perms[resource] = {};
      Object.keys(availableResources[resource]).forEach(action => {
        perms[resource][action] = {
          allowed: false,
          id: (availableResources[resource][action] && availableResources[resource][action].id) || null
        };
      });
    });
    return perms;
  };

  handleTabSelect = (tabId) => {
    this.setState({ 
      permissionType: tabId, 
      selectedEntityId: "",
      permissions: this.getInitialPermissions(),
      dropdownKey: `dropdown-${tabId}-${Date.now()}`
    });
  };

  handleEntitySelect = async (item) => {
    const selectedId = item.id;
    this.setState({ selectedEntityId: selectedId });
    this.loadEntityPermissions(selectedId);
  };

  loadEntityPermissions = async (entityId) => {
    const { permissionType } = this.state;
    const permissionTypeText = permissionType.text || permissionType;
    try {
      const matrix = await CompanyService.getEntityPermissions(permissionTypeText.toLowerCase(), entityId);
      this.setState({ permissions: matrix });
    } catch (error) {
      console.error("Error fetching entity permissions", error);
    }
  };

  onCheckboxChange = (resource, action, e) => {
    const checked = e.target.checked;
    this.setState(prevState => {
      const newPermissions = { ...prevState.permissions };
      if (newPermissions[resource] && newPermissions[resource][action]) {
        newPermissions[resource][action] = {
          ...newPermissions[resource][action],
          allowed: checked
        };
      }
      return { permissions: newPermissions };
    });
  };

  onSave = async () => {
    const { permissionType, selectedEntityId, permissions } = this.state;
    if (!selectedEntityId) {
      alert(`Please select a ${permissionType}`);
      return;
    }
    try {
      const permissionTypeText = permissionType.text || permissionType;
      await CompanyService.updatePermissions(permissions, permissionTypeText, selectedEntityId);
      alert("Permissions saved successfully!");
    } catch (error) {
      console.error("Error saving permissions", error);
      alert("Error saving permissions");
    }
  };

  render() {
    const { permissionType, availableResources, permissions, dropdownKey, selectedEntityId } = this.state;

    const permissionTypeText = permissionType.text || permissionType;
    const dropdownType = permissionTypeText.toLowerCase() === 'user' ? 'users' : 'roles';

    return (
      <div className='permission_manager'>
        <div className='permission_manager__body'>
          <h1>Manage Permissions</h1>
          <Tabs onSelect={this.handleTabSelect} selected={permissionType.text ? permissionType.text : permissionType}>
            <Tab 
              id="User" 
              icon={<Icon.User size={18} strokeWidth={1.5} />} 
              text="User" 
            />
            <Tab 
              id="Role" 
              icon={<Icon.Users size={18} strokeWidth={1.5} />} 
              text="Role" 
            />
          </Tabs>

          <div className="permission_manager__dropdown">
            <SearchableDropdown 
              key={dropdownKey}
              type={dropdownType}
              onSelect={this.handleEntitySelect}
              searchPlaceHolder={`Select ${permissionType}`}
            />
          </div>
          {selectedEntityId && (
          <div>
            {Object.keys(availableResources).map(resource => (
              <div key={resource} className="permission_manager__resource">
                <h2>{resource}</h2>
                {Object.keys(availableResources[resource]).map(action => (
                  <Checkbox
                    key={action}
                    containerClass="engagement__body__input"
                    title={action.charAt(0).toUpperCase() + action.slice(1)}
                    name={`${resource}-${action}`}
                    checked={
                      permissions[resource] && permissions[resource][action]
                        ? permissions[resource][action].allowed
                        : false
                    }
                    onChange={e => this.onCheckboxChange(resource, action, e)}
                  />
                ))}
              </div>
            ))}

          <Button text="Save Permissions" onClick={this.onSave} view="secondary" className="ft-save-permissions-btn" />
          </div>
          )}

          {!selectedEntityId && (<div className='permission_manager__resourceselection'>Select a resource to get started</div>)}

        </div>
      </div>
    );
  }
}

export default PermissionsManager;
